export default __webpack_public_path__ + "static/media/football.acd08b13.webp";